/**
 * @generated SignedSource<<fb7c1e8d03c1fea442ed0cf448a90465>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RecapLanguage_note$data = {
  readonly id: string;
  readonly isLocked: boolean;
  readonly meetingRecordings: ReadonlyArray<{
    readonly id: string;
    readonly viewerCanDelete: boolean;
    readonly " $fragmentSpreads": FragmentRefs<"RecapHistory_meetingRecording" | "RegenerateForLanguageModalFragment_meetingRecording" | "utils_useLongestMeetingRecording_meetingRecordings">;
  }> | null;
  readonly stream: {
    readonly isExternal: boolean;
  };
  readonly viewerCanEdit: boolean;
  readonly " $fragmentSpreads": FragmentRefs<"MenuItemTooltip_useGetPropsForExternalWorkspaces_note">;
  readonly " $fragmentType": "RecapLanguage_note";
};
export type RecapLanguage_note$key = {
  readonly " $data"?: RecapLanguage_note$data;
  readonly " $fragmentSpreads": FragmentRefs<"RecapLanguage_note">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RecapLanguage_note",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "viewerCanEdit",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isLocked",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "NoteStream",
      "kind": "LinkedField",
      "name": "stream",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isExternal",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "MeetingRecording",
      "kind": "LinkedField",
      "name": "meetingRecordings",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "viewerCanDelete",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "RecapHistory_meetingRecording"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "utils_useLongestMeetingRecording_meetingRecordings"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "RegenerateForLanguageModalFragment_meetingRecording"
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "MenuItemTooltip_useGetPropsForExternalWorkspaces_note"
    }
  ],
  "type": "Note",
  "abstractKey": null
};
})();

(node as any).hash = "fcaf29a39d153cad8a95d0fa4945c444";

export default node;
